// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mat-form-field{
    width: 100%;
}
form small.error{
    position: relative;
    top: -24px;
}
a{
    color: #DA512D;
    text-decoration: none;
}
/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNhZnJhdHRpLWZlZS1zdHJ1Y3R1cmUtYWRkLmNvbXBvbmVudC5jc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7SUFDSSxXQUFXO0FBQ2Y7QUFDQTtJQUNJLGtCQUFrQjtJQUNsQixVQUFVO0FBQ2Q7QUFDQTtJQUNJLGNBQWM7SUFDZCxxQkFBcUI7QUFDekIiLCJmaWxlIjoic2FmcmF0dGktZmVlLXN0cnVjdHVyZS1hZGQuY29tcG9uZW50LmNzcyIsInNvdXJjZXNDb250ZW50IjpbIi5tYXQtZm9ybS1maWVsZHtcbiAgICB3aWR0aDogMTAwJTtcbn1cbmZvcm0gc21hbGwuZXJyb3J7XG4gICAgcG9zaXRpb246IHJlbGF0aXZlO1xuICAgIHRvcDogLTI0cHg7XG59XG5he1xuICAgIGNvbG9yOiAjREE1MTJEO1xuICAgIHRleHQtZGVjb3JhdGlvbjogbm9uZTtcbn0iXX0= */`, "",{"version":3,"sources":["webpack://./src/app/secure/setup/safratti-fee-structure-add/safratti-fee-structure-add.component.css"],"names":[],"mappings":"AAAA;IACI,WAAW;AACf;AACA;IACI,kBAAkB;IAClB,UAAU;AACd;AACA;IACI,cAAc;IACd,qBAAqB;AACzB;AACA,olBAAolB","sourcesContent":[".mat-form-field{\n    width: 100%;\n}\nform small.error{\n    position: relative;\n    top: -24px;\n}\na{\n    color: #DA512D;\n    text-decoration: none;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
